import { useState } from 'react';
import { Trans } from 'react-i18next';
import { Tooltip } from '@material-ui/core';
import { put } from 'helpers/apiHelpers';
import makeStyles from '@material-ui/styles/makeStyles';
import IconPauseCircleFill from 'assets/Icons/IconPauseCircleFill';
import classNames from 'classnames';
import IconPlayCircleFill from 'assets/Icons/IconPlayCircleFill';

const useStyles = makeStyles({
  button: {
    lineHeight: 0,
    background: 'transparent',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
  },
  buttonLoading: {
    cursor: 'not-allowed',
  },
});

const SubscriptionPause = ({ subscription, onUpdate }) => {
  const [isLoading, setIsLoading] = useState(false);

  const classes = useStyles();

  const toggleSubscriptionState = async () => {
    setIsLoading(true);

    try {
      await put(`/subscription/${subscription.id}`, {
        enabled: !subscription.active,
      });

      onUpdate();
    } finally {
      setIsLoading(false);
    }
  };

  if (subscription.markedToRemove) {
    return null;
  }

  if (!subscription.active) {
    return (
      <Tooltip
        placement="top"
        title={
          <Trans
            i18nKey="subscription.dialog.pause.activate.tooltip"
            components={{ br: <br /> }}
          />
        }
      >
        <button
          type="button"
          disabled={isLoading}
          onClick={toggleSubscriptionState}
          className={classNames({
            [classes.button]: true,
            [classes.buttonLoading]: isLoading,
          })}
        >
          <IconPlayCircleFill />
        </button>
      </Tooltip>
    );
  }

  return (
    <Tooltip
      placement="top"
      title={
        <Trans
          i18nKey="subscription.dialog.pause.pause.tooltip"
          components={{ br: <br /> }}
        />
      }
    >
      <button
        type="button"
        disabled={isLoading}
        onClick={toggleSubscriptionState}
        className={classNames({
          [classes.button]: true,
          [classes.buttonLoading]: isLoading,
        })}
      >
        <IconPauseCircleFill />
      </button>
    </Tooltip>
  );
};

export default SubscriptionPause;
